import { FCC } from "@/types";

export const WelcomeCard: FCC = ({ children }) => (
  <div className="w-full max-w-[599px] rounded-lg bg-background-secondary p-4 desktop:p-8">
    {children}
  </div>
);
